export class BlobFile {
  constructor(blob) {
    this.handle = void 0;
    this.size = void 0;
    this.bigsize = void 0;
    this.url = void 0;
    this.handle = blob instanceof ArrayBuffer ? new Blob([blob]) : blob;
    this.size = blob instanceof ArrayBuffer ? blob.byteLength : blob.size;
    this.bigsize = BigInt(this.size);
    this.url = blob instanceof File ? blob.name : '';
  }
  async close() {}
  async stat() {
    return {
      size: this.handle.size,
      bigsize: BigInt(this.handle.size),
      isDirectory: false
    };
  }
  async read(start, length) {
    const arrayBuffer = await this.handle.slice(start, start + length).arrayBuffer();
    return arrayBuffer;
  }
}
//# sourceMappingURL=blob-file.js.map